import { render } from "./Loader2.vue?vue&type=template&id=b845aba0&scoped=true"
import script from "./Loader2.vue?vue&type=script&lang=js"
export * from "./Loader2.vue?vue&type=script&lang=js"

import "./Loader2.vue?vue&type=style&index=0&id=b845aba0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b845aba0"]])

export default __exports__